export const MACHINE_PICTURE_FIELDS = [
  {id: 'machine', label: 'Machine', align: "left"},
  {id: 'dateTime', label: 'Date Time', align: "left"},
  {id: 'files', label: 'Pictures', align: "left"},
  {},
  {}

]